import whatTheLogo from "../assets/whatthe-logo.png";
import heroFood from "../assets/hero-food.webp";
import heroBody from "../assets/hero-body.webp";

export const BRAND = {
  name: "WhatThe?",
  full: "WhatThe? Ingredient Scanner",
  logo: whatTheLogo,
  domain: "whatthescan.app",
  tagline: "Smarter choices, inside and out",
  appStoreUrl: "https://apps.apple.com/app/id6803412813",
  subhead:
    "Take the mystery out of what goes into your body and onto your skin. Simply scan to find out what's good for you and what isn't. No ongoing subscription — Buy one, or both, own forever.",
};

export const SCANNERS = [
  {
    key: "food",
    index: "01",
    name: "WhatThe? Food",
    short: "Food",
    palette: "food",
    bg: "#E7F7EE",
    text: "#166534",
    accent: "#16A34A",
    tagline:
      "Ever wondered what those ingredients on your food labels are actually doing to your body? With WhatThe? Food, you can scan or upload an ingredient list for an instant analysis showing calories, macronutrients and allergen breakdowns — in plain English.",
    screenshot: heroFood,
    hideCardDetails: true,
    detail: {
      body:
        "Ever wondered what those ingredients on your food labels are actually doing to your body? With WhatThe? Food, you can scan or upload an ingredient list for an instant analysis showing calories, macronutrients and allergen breakdowns — in plain English.",
      features: [
        "Instant ingredient list analysis",
        "Safe, Caution or Avoid verdicts",
        "Plated meal recognition for instant nutrition breakdown",
        "Additive, preservative and hidden sugar flags",
        "Personal dietary preferences and allergies",
        "Suggested alternatives — no sponsored products",
      ],
    },
    pointsLabel: "Key features",
    points: [
      "Instant ingredient list analysis",
      "Safe, Caution or Avoid verdicts",
      "Plated meal recognition for instant nutrition breakdown",
      "Additive, preservative and hidden sugar flags",
      "Personal dietary preferences and allergies",
      "Suggested alternatives — no sponsored products",
    ],
  },
  {
    key: "body",
    index: "02",
    name: "WhatThe? Body",
    short: "Body",
    palette: "bodycare",
    bg: "#F3E8FF",
    text: "#6D28D9",
    accent: "#8B5CF6",
    tagline:
      "What you put on your skin matters just as much as what you eat. With WhatThe? Body, you can scan or upload the ingredient list on skincare, toiletries and cosmetics for an instant analysis of irritants, endocrine disruptors, allergens and potentially harmful chemicals and fragrances.",
    screenshot: heroBody,
    hideCardDetails: true,
    detail: {
      body:
        "What you put on your skin matters just as much as what you eat. With WhatThe? Body, you can scan or upload the ingredient list on skincare, toiletries and cosmetics for an instant analysis of irritants, endocrine disruptors, allergens and potentially harmful chemicals and fragrances.",
      features: [
        "Instant ingredient list analysis",
        "Safe, Caution or Avoid verdicts",
        "Hormone-disrupting and harmful chemical flags",
        "Fragrance and allergen identification",
        "Personal Skin Profile",
        "Suggested alternatives — no sponsored products",
      ],
    },
    pointsLabel: "Key features",
    points: [
      "Instant ingredient list analysis",
      "Safe, Caution or Avoid verdicts",
      "Hormone-disrupting and harmful chemical flags",
      "Fragrance and allergen identification",
      "Personal Skin Profile",
      "Suggested alternatives — no sponsored products",
    ],
  },
];

export const WHY = [
  {
    title: "Obsolete by Design",
    body: "Most scanning apps rely on pre-stored, often outdated databases. They match a barcode to a database entry and return a score — with no explanation of what it actually means for you.",
  },
  {
    title: "Smart Answers",
    body: "Powered by advanced AI, WhatThe? reads ingredient lists and explains what a product is, what's in it and how it may affect you. In plain English. Not just a red flag, but a clear picture of what's going into your body and onto your skin.",
  },
  {
    title: "Pay once, own forever",
    body: "No subscription, ever. Each scanner comes with a generous 1,000 scan allowance with the option to buy more if needed.",
  },
  {
    title: "No Data Tracking",
    body: "No accounts, no servers, no data to sell. Your scans stay on your device.",
  },
];

export const COMPARISON = [
  { feature: "Visual AI (OCR & plate scans)", whatthe: true, others: false },
  { feature: "Household cleaner coverage", whatthe: true, others: false },
  { feature: "Pay-once lifetime pricing", whatthe: true, others: false },
  { feature: "No monthly subscription", whatthe: true, others: false },
  { feature: "Zero data tracking", whatthe: true, others: false },
  { feature: "Food & barcode scanning", whatthe: true, others: true },
];

export const BUNDLES = [
  {
    key: "single",
    name: "WhatThe? Food Only",
    price: "$29.99",
    note: "one-time",
    badge: null,
    highlight: false,
    scans: "1,000 lifetime scans included for this scanner.",
    items: ["WhatThe? Food"],
  },
  {
    key: "single-body",
    name: "WhatThe? Body Only",
    price: "$29.99",
    note: "one-time",
    badge: null,
    highlight: false,
    scans: "1,000 lifetime scans included for this scanner.",
    items: ["WhatThe? Body"],
  },
  {
    key: "duo",
    name: "2 Scanner Bundle",
    price: "$49.99",
    note: "one-time",
    badge: "Best Value",
    highlight: true,
    scans: "3,000 scans across Food & Body",
    items: ["WhatThe? Food", "WhatThe? Body"],
  },
];

export const TOPUPS = [
  { key: "starter", name: "Light Pack", scans: "100 scans", price: "$2.99" },
  { key: "power", name: "Power Pack", scans: "250 scans", price: "$6.99" },
  { key: "bulk", name: "Bulk Pack", scans: "500 scans", price: "$12.99" },
];
